module.exports = __webpack_public_path__ + "static/xpreviews-ef3ce0cca5b42bd9813c75d140224c6f.png";